/**
 * @function assistant_parse_answer
 * парсит строку ответа ассистента и возвращает объект с массивом ресторанов и сообщением
 * работает на основе структуры текста (двойные переносы строк), не зависит от конкретных лейблов
 */
export const assistant_parse_answer = (answer: string | null | undefined) => {
  if (!answer) return { restaurants: [], message: '' }

  // разбиваем по двойному переводу строки (разделяет рестораны)
  const blocks = answer
    .split(/\n{2,}/)
    .map((b) => b.trim())
    .filter(Boolean)

  // обрабатываем блоки: первый - сообщение, остальные проверяем на рестораны
  const message = blocks[0] || ''
  const restaurants = []

  for (let i = 1; i < blocks.length; i++) {
    const block = blocks[i]

    // разбиваем по переводу строки (разделяет поля)
    const lines = block
      .split(/\n/)
      .map((l) => l.trim())
      .filter(Boolean)

    let name = ''
    let conclusion = ''
    let address = ''
    let url = ''
    let id = null

    // первая строка - название ресторана
    if (lines.length > 0) {
      name = lines[0]
      // убираем лейбл "Название заведения:" если он присутствует
      if (name.startsWith('Название заведения:')) {
        name = name.replace('Название заведения:', '').trim()
      }
    }

    // ищем url в строках (начинается с http)
    const urlLine = lines.find((line) => line.startsWith('http'))
    if (urlLine) {
      url = urlLine.trim()
      // id — это число в конце url перед последним слэшем или параметрами
      const match = url.match(/-(\d+)(?:\/?|\?|$)/)
      if (match) id = Number(match[1])
    }

    // ищем адрес: первая короткая строка (<= 80 символов), не название и не url, после названия
    let addressIdx = -1
    for (let j = 1; j < lines.length; j++) {
      const line = lines[j]
      if (line !== name && !line.startsWith('http') && line.length > 0 && line.length <= 80) {
        address = line.startsWith('Адрес:') ? line.replace('Адрес:', '').trim() : line
        addressIdx = j
        break
      }
    }

    // всё между названием и адресом — это conclusion
    let conclusionLines = []
    if (addressIdx > 1) {
      conclusionLines = lines.slice(1, addressIdx)
    } else {
      // если адрес не найден, всё кроме названия, url и адреса — это conclusion
      conclusionLines = lines.filter((line) => {
        return (
          line !== name &&
          line !== address &&
          line !== url &&
          !line.startsWith('Название заведения:') &&
          !line.startsWith('Адрес:') &&
          line.length > 0 &&
          !line.startsWith('http')
        )
      })
    }
    if (conclusionLines.length > 0) {
      conclusion = conclusionLines.join(' ')
    }

    // добавляем ресторан только если есть id и название
    if (id && name) {
      restaurants.push({ name, conclusion, address, url, id })
    }
  }

  return { restaurants, message }
}
